<script>
import axios from "axios";

export default {
  props: {
    isEdit: false
  },
  data() {
    return {
      token: null,
      password: null,
      passwordConfirm: null,
      flash: null,
    }
  },
  mounted() {
    this.token = this.$route.params.token
  },
  methods: {
    showHidePassword() {
      let field = document.querySelector('#password')

      field.type === 'text' ? field.type = 'password' : field.type = 'text'
    },
    showHideConfirmPassword() {
      let field = document.querySelector('#passwordConfirm')

      field.type === 'text' ? field.type = 'password' : field.type = 'text'
    },
    clearFlash() {
      this.flash = null
    },
    checkPassword() {

      if (this.password === null || this.passwordConfirm === null) {
        this.flash = {message: 'Mot de passe et confirmation requis', type: 'danger'}
      } else if (this.password !== this.passwordConfirm) {
        this.flash = {message: 'Mot de passe et confirmation non identique', type: 'danger'}
      } else {
        const data = {
          password: this.password,
          passwordConfirm: this.passwordConfirm
        }
        axios.post(process.env.VUE_APP_API_URL + '/reset-password/reset/' + this.token, data)
            .then(response => {
              this.flash = {message: 'Mot de passe sauvegardé', type: 'success'}

              setTimeout(() => {
                this.$router.push('/')
              }, 2000)
            })
            .catch(e => {
              this.flash = {message: 'Une erreur est survenue, veuillez reesayer plus tard', type: 'danger'}
            })
      }
    }
  }
}
</script>

<template>
  <div class="container">

    <div class="position-fixed top-0 translate-middle-x p-3" style="right: 0;">
      <div :class="'toast bg-'+ flash.type + ' ' + (flash?'show':'hide')" v-if="flash">
        <div class="d-flex">
          <div class="toast-body">
            {{ flash.message }}
          </div>
          <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast"
                  aria-label="Fermer"
                  @click="clearFlash"></button>
        </div>
      </div>
    </div>
    <form @submit.prevent="checkPassword()">
      <label for="password" class="form-label">Mot de passe</label>
      <div class="input-group mb-3">
        <input type="password" class="form-control"  id="password" placeholder="Mot de passe" v-model="password">
        <div class="input-group-append" id="password">
          <span class="input-group-text" id="basic-addon2" @click="showHidePassword()"><i class="fa-regular fa-eye"></i></span>
        </div>
      </div>
      <label for="passwordConfirm" class="form-label">Confirmation mot de passe</label>
      <div class="input-group mb-3">
        <input type="password" class="form-control"  id="passwordConfirm" placeholder="Confirmation mot de passe" v-model="passwordConfirm">
        <div class="input-group-append" id="passwordConfirm">
          <span class="input-group-text" id="basic-addon2" @click="showHideConfirmPassword()"><i class="fa-regular fa-eye"></i></span>
        </div>
      </div>
      <button type="submit" class="btn btn-primary" v-if="isEdit">MODIFICATION MOT DE PASSE</button>
      <button type="submit" class="btn btn-primary" v-else>CREATION MOT DE PASSE</button>
    </form>
  </div>
</template>

<style scoped>
.fa-eye{
  color: black;
  cursor: pointer;
}
.input-group-text {
  padding: 10px 10px 10px 10px !important;
  border-color: rgba(29, 37, 59, 0.5) !important;
}

</style>